import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    AKCE_URL,
    AKCE_BY_ID_URL,
    AKCE_ODPOVED_URL,
    AKCE_NOTIFIKACE_URL,
    AKCE_NADCHAZEJICI_URL,
} from "../url";
import type { Akce, AkceDetail, AkceOdpoved, CreateAkceRequest, UpdateAkceRequest, PagedResponseAkce } from "../generated/models/Akce";

// -----------------------------
// SEARCH PARAMS
// -----------------------------

export interface SearchAkceParams {
    query?: string;
    typ?: string;
    dateFrom?: string;
    dateTo?: string;
    aktivni?: boolean;
    page?: number;
    size?: number;
    sortBy?: string;
    sortOrder?: string;
}

// -----------------------------
// AKCE API
// -----------------------------

const searchAkce = (params: SearchAkceParams) => {
    const queryParams = new URLSearchParams();
    if (params.query) queryParams.append('query', params.query);
    if (params.typ) queryParams.append('typ', params.typ);
    if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
    if (params.dateTo) queryParams.append('dateTo', params.dateTo);
    if (params.aktivni !== undefined) queryParams.append('aktivni', String(params.aktivni));
    if (params.page !== undefined) queryParams.append('page', String(params.page));
    if (params.size !== undefined) queryParams.append('size', String(params.size));
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

    const queryString = queryParams.toString();
    const url = queryString ? `${AKCE_URL}?${queryString}` : AKCE_URL;
    return handleRequest<PagedResponseAkce>(() => axiosInstance.get(url));
};

const getAkceDetail = (id: number) => {
    return handleRequest<AkceDetail>(() =>
        axiosInstance.get(AKCE_BY_ID_URL(id))
    );
};

const createAkce = (data: CreateAkceRequest) => {
    return handleRequest<Akce>(() =>
        axiosInstance.post(AKCE_URL, data)
    );
};

const updateAkce = (id: number, data: UpdateAkceRequest) => {
    return handleRequest<Akce>(() =>
        axiosInstance.put(AKCE_BY_ID_URL(id), data)
    );
};

const deleteAkce = (id: number) => {
    return handleRequest(() =>
        axiosInstance.delete(AKCE_BY_ID_URL(id))
    );
};

const getMyOdpoved = (akceId: number) => {
    return handleRequest<AkceOdpoved | null>(() =>
        axiosInstance.get(AKCE_ODPOVED_URL(akceId))
    );
};

const submitOdpoved = (akceId: number, odpoved: 'BUDU' | 'NEBUDU') => {
    return handleRequest<AkceOdpoved>(() =>
        axiosInstance.post(AKCE_ODPOVED_URL(akceId), { odpoved })
    );
};

const sendNotifikace = (akceId: number) => {
    return handleRequest<{ success: boolean; odeslano: number; message: string }>(() =>
        axiosInstance.post(AKCE_NOTIFIKACE_URL(akceId))
    );
};

const getNadchazejiciAkce = (days: number = 30) => {
    return handleRequest<Akce[]>(() =>
        axiosInstance.get(AKCE_NADCHAZEJICI_URL, { params: { days } })
    );
};

const AkceServiceApi = {
    searchAkce,
    getAkceDetail,
    createAkce,
    updateAkce,
    deleteAkce,
    getMyOdpoved,
    submitOdpoved,
    sendNotifikace,
    getNadchazejiciAkce,
};

export default AkceServiceApi;
